/**
 * ? @description : Create Teacher By Admin
 */

// Dependencies
import React from "react";
// import {Spinner } from "react-bootstrap";

// Axios Component
// import Axios from "./Components/teacherapi/TeacherApi";

// CSS Component
import "./App.css";

// Components
import TitleBar from "./Components/header/TitleBar";
// import PrimaryInfo from "./Components/lte-teacher-volunteer/PrimaryInfo";
// import APRInfo from "./Components/lte-teacher-volunteer/APRInfo";
// import PrereqInfo from "./Components/lte-teacher-volunteer/PrereqInfo";
// import ThankyouModal from "./Components/thankyou-modal/ThankyouModal";
// import { Stepper, Step } from 'react-form-stepper';
import AllRoutes from "./Components/routes/AllRoutes";
// import ParentInfo from "./Components/lte-teacher-volunteer/ParentInfo";

function App() {

  // * Logged User Name
  // const username = sessionStorage.getItem("username");

  // * State Variables
  // const [page, setPage] = useState(0);
  // const [show, handleShow] = useState(false);
  // const [loading, setLoading] = useState(false);
  // const [formData, setFormData] = useState({
  //   teacher_name: "",
  //   contactno: "",
  //   email: "",
  //   spoke_lang_1: "",
  //   is_apr_residing: null,
  //   apr_homeaddress: "",
  //   apr_reference_contact: "",
  //   have_student_already: "",
  //   tentative_start_date: "",
  //   role: "volunteer",
  //   teacher_status: "active",
  //   group_status: "ungrouped",
  //   teacher_mapped_status: "unmapped",
  //   audio_status: "unsubmitted",
  //   is_commitment_three_months: false,
  //   is_agreed_lte_policy: false,
  //   spoke_lang_2: "",
  //   spoke_lang_3: "",
  //   spoke_lang_4: "",
  //   spoke_lang_5: "",
  //   spoke_lang_6: "",
  //   apr_reference_name: "",
  //   group_id: null,
  //   group_name: null,
  //   mapped_to_student: null,
  //   batch_member_id: null,
  //   map_id: null,
  //   note_description: null,
  //   created_by: username,
  //   // address: "",
  //   // pincode: "",
  //   // country: "",
  //   // city: "",
  //   // is_above_ninth_grade: "",
  //   // parent_name: "",
  //   // parent_contactno: "",
  // });
  // const [validationRes, setValidationRes] = useState({
  //   isInvalidTeacherName: false,
  //   isInvalidTeacherNameFormate: false,
  //   isInvalidTeacherMobileNumber: false,
  //   isInvalidTeacherMobileNumberFormate: false,
  //   isInvalidTeacherMailId: false,
  //   isInvalidSpokenLanguage1: false,
  //   isInvalidAprResiding: false, 
  //   isInvalidAprHomeAddress: false,
  //   isInvalidAprReferenceNumber: false,
  //   isInvalidAprReferenceName: false,
  //   isInvalidHaveStudentAlready: false,
  //   isInvalidStartDate: false,
  //   // isInvalidTeacherHomeAddress: false,
  //   // isInvalidTeacherPincode: false,
  //   // isInvalidTeacherCountry: false,
  //   // isInvalidTeacherState: false,
  //   // isInvalidParentName: false,
  //   // isInvalidParentMobileNumber: false,
  //   // isInvalidAboveNinthGrade: false, // Added on 12-08-2022
  // });

  // * Initialize Header in Array Format
  // const FormTitles = [
  //   "Primary Information",
  //   "Adarsh Palm Retreat Information",
  //   "Other information",
  //   // "Parent Information",
  // ];

  // const backdropSpinner = (
  //   <div id="backdrop">
  //     <Spinner style={{
  //       display: "block",
  //       position: "fixed",
  //       top: "calc(50% - (58px / 2))",
  //       right: "calc(50% - (58px / 2))",
  //     }} animation="border" variant="primary" />
  //   </div>
  // )

  // * Condition to Render Form Data Tab
  // const PageDisplay = () => {
  //   if (page === 0) {
  //     return (
  //       <PrimaryInfo
  //         formData={formData}
  //         setFormData={setFormData}
  //         validationRes={validationRes}
  //         setValidationRes={setValidationRes}
  //       />
  //     );
  //   } else if (page === 1) {
  //     return (
  //       <APRInfo
  //         formData={formData}
  //         setFormData={setFormData}
  //         validationRes={validationRes}
  //         setValidationRes={setValidationRes}
  //       />
  //     );
  //   } else {
  //     return (
  //       <PrereqInfo
  //         formData={formData}
  //         setFormData={setFormData}
  //         validationRes={validationRes}
  //         setValidationRes={setValidationRes}
  //       />
  //     );
  //   }
  //   // else {
  //   //   return (
  //   //     <ParentInfo
  //   //       formData={formData}
  //   //       setFormData={setFormData}
  //   //       validationRes={validationRes}
  //   //       setValidationRes={setValidationRes}
  //   //     />
  //   //   );
  //   // }
  // };

  // TODO : Email Validation Pattern
  // const checkInvalidEmail = (email) => {
  //   var pattern = new RegExp(
  //     /^(("[\w-\s]+")|([\w-]+(?:\.[\w-]+)*)|("[\w-\s]+")([\w-]+(?:\.[\w-]+)*))(@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][0-9]\.|1[0-9]{2}\.|[0-9]{1,2}\.))((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\.){2}(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[0-9]{1,2})\]?$)/i
  //   );
  //   var result = pattern.test(email);
  //   return !result;
  // };

  // TODO : Validate Primary Tab Form Fields
  // const primaryValidation = () => {
  //   var canMoveToNextPage = true;
  //   var invalidName = false;
  //   var invalidMobile = false;
  //   var invalidEmail = false;
  //   var invalidSpokenLang1 = false;

  //   if (
  //     formData.teacher_name.length === 0 ||
  //     formData.teacher_name.length > 20
  //   ) {
  //     invalidName = true;
  //     canMoveToNextPage = false;
  //   }

  //   if (!(formData.contactno.length === 10)) {
  //     invalidMobile = true;
  //     canMoveToNextPage = false;
  //   }

  //   if (formData.email.length === 0) {
  //     invalidEmail = true;
  //     canMoveToNextPage = false;
  //   } 
  //   // else {
  //   //   if (checkInvalidEmail(formData.email)) {
  //   //     invalidEmail = true;
  //   //     canMoveToNextPage = false;
  //   //   }
  //   // }

  //   if (
  //     formData.spoke_lang_1.length === 0 ||
  //     formData.spoke_lang_1.length > 20
  //   ) {
  //     canMoveToNextPage = false;
  //     invalidSpokenLang1 = true;
  //   }

  //   setValidationRes({
  //     ...validationRes,
  //     isInvalidTeacherName: invalidName,
  //     isInvalidTeacherMobileNumber: invalidMobile,
  //     isInvalidTeacherMailId: invalidEmail,
  //     isInvalidSpokenLanguage1: invalidSpokenLang1,
  //   });
  //   return canMoveToNextPage;
  // };

  // TODO : Validate APR Tab Form Fields
  // const aprValidation = () => {
  //   var canMoveToNextPage = true;
  //   var invalidResiding = false;
  //   var invalidAprHomeAddress = false;
  //   var invalidAprMobile = false;
  //   var invalidAprName = false;
  //   // var invalidPincode = false;
  //   // var invalidCountry = false;
  //   // var invalidState = false;

  //   if(formData.is_apr_residing){

  //     // if (formData.is_apr_residing.length === 0) {
  //     //   invalidResiding = true;
  //     //   canMoveToNextPage = false;
  //     // }
  //     if(formData.apr_homeaddress === ""){
  //       invalidAprHomeAddress = true;
  //       canMoveToNextPage = false;
  //     }
  //   }else{
  //     if (!(formData.apr_reference_contact.length === 10)) {
  //       invalidAprMobile = true;
  //       canMoveToNextPage = false;
  //     }
  
  //     if (formData.apr_reference_name.length === 0 || formData.apr_reference_name.length > 20) {
  //       invalidAprName = true;
  //       canMoveToNextPage = false;
  //     }
  //   }

   

  //   /*if (!(formData.pincode.length === 6)) {
  //     invalidPincode = true;
  //     canMoveToNextPage = false;
  //   }

  //   if (formData.country.length === 0 || formData.country.length > 30) {
  //     invalidCountry = true;
  //     canMoveToNextPage = false;
  //   }

  //   if (formData.city.length === 0 || formData.city.length > 30) {
  //     invalidState = true;
  //     canMoveToNextPage = false;
  //   } */

  //   setValidationRes({
  //     ...validationRes,
  //     isInvalidAprResiding: invalidResiding,
  //     isInvalidAprHomeAddress: invalidAprHomeAddress,
  //     isInvalidAprReferenceNumber: invalidAprMobile,
  //     isInvalidAprReferenceName : invalidAprName
  //     /*isInvalidTeacherHomeAddress: invalidAddress,
  //     isInvalidTeacherPincode: invalidPincode,
  //     isInvalidTeacherCountry: invalidCountry,
  //     isInvalidTeacherState: invalidState, */
  //   });
  //   return canMoveToNextPage;
  // };

  // TODO : Validate Pre-Requisite Tab Form Fields
  // const prereqValidation = () => {
  //   var canMoveToNextPage = true;
  //   // var invalidAboveNinthGrade = false;
  //   var invalidHaveStudentAlready = false;
  //   var invalidTentativeDate = false;

  //   /* if (formData.is_above_ninth_grade.length === 0) {
  //     invalidAboveNinthGrade = true;
  //     canMoveToNextPage = false;
  //   } */

  //   if (formData.have_student_already.length === 0) {
  //     invalidHaveStudentAlready = true;
  //     canMoveToNextPage = false;
  //   }

  //   if (formData.tentative_start_date.length === 0) {
  //     invalidTentativeDate = true;
  //     canMoveToNextPage = false;
  //   }

  //   setValidationRes({
  //     ...validationRes,
  //     // isInvalidAboveNinthGrade: invalidAboveNinthGrade,
  //     isInvalidHaveStudentAlready: invalidHaveStudentAlready,
  //     isInvalidStartDate: invalidTentativeDate,
  //   });
  //   return canMoveToNextPage;
  // };
  
  // TODO : Validate Parent Tab Form Fields
  /* const parentValidation = () => {
    var canMoveToNextPage = true;
    var invalidParentName = false;
    var invalidParentNumber = false;

    if (formData.parent_name.length === 0 || formData.parent_name.length > 20) {
      invalidParentName = true;
      canMoveToNextPage = false;
    }

    if (!(formData.parent_contactno.length === 10)) {
      invalidParentNumber = true;
      canMoveToNextPage = false;
    }

    setValidationRes({
      ...validationRes,
      isInvalidParentName: invalidParentName,
      isInvalidParentMobileNumber: invalidParentNumber,
    });
    return canMoveToNextPage;
  }; */

  // ? Post Method : API Call to Submit Teacher Data
  // async function postData() {
  //   try {
  //     setLoading(true);
  //     let options = {
  //       method: "POST",
  //       url: "/teacher",
  //       auth: true,
  //       data: formData,
  //     };

  //     const response = await Axios(
  //       options.method,
  //       options.url,
  //       options.auth,
  //       options.data
  //     );

  //     if (response.status === 201) {
  //       // alert("Form data submitted successfully !");
  //       handleShow(true);
  //       setLoading(false);
  //       // window.location.reload();      

  //     }

  //   } catch (error) {
  //     alert("Error occurred ! Please try again later.");
  //     setLoading(false);
  //   }
  // }
  // console.log(formData);
  return (
    <div>
      <TitleBar></TitleBar>
      <AllRoutes></AllRoutes>
    </div>
  );
}

export default App;